export default "__VITE_ASSET__d8eac25c__"